import { render } from "./PostInstall.vue?vue&type=template&id=4e4dedac&scoped=true"
import script from "./PostInstall.vue?vue&type=script&lang=js"
export * from "./PostInstall.vue?vue&type=script&lang=js"

import "./PostInstall.vue?vue&type=style&index=0&id=4e4dedac&scoped=true&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4dedac"]])

export default __exports__